import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-nowrap items-stretch h-screen" }
const _hoisted_2 = { class: "flex-auto overflow-x-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "opacity-45" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "flex justify-end py-2 px-4"
}

import HeaderComponent from '@/components/HeaderComponent.vue';
import ConfigSubsection from '@/components/config-screen/ConfigSubsection.vue';
import PartnerProviderCard from '@/components/config-screen/PartnerProviderCard.vue';
import { computed, ref } from 'vue';
import { Button } from '@/components/ui/button';
import { PartnerProvider } from '@/http/partnerProvider';
import { GET_PARTNER_PROVIDERS, RETRIEVE_PARTNER_PROVIDERS } from '@/store';
import { useStore } from 'vuex';
import PartnerProviderCreationForm from '@/components/config-screen/PartnerProviderCreationForm.vue';
import ChatConfig from '@/components/config-screen/ChatConfig.vue';
import { toast } from '@/components/ui/toast';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigView',
  setup(__props) {

const store = useStore();

store.dispatch(RETRIEVE_PARTNER_PROVIDERS);
const partnerProviders = computed<PartnerProvider[]>(() => Object.values(store.getters[GET_PARTNER_PROVIDERS]));

const showAddPartnerProvider = ref(false);

const disableCreationForm = () => {
    showAddPartnerProvider.value = false;
};

const showToastMessage = (title: string, variant: "default" | "destructive", description?: string) => {
    toast({
       title: title,
       description: description,
       variant: variant 
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Toaster = _resolveComponent("Toaster")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderComponent, {
        class: "flex-1 flex-grow-0",
        title: "Configurações"
      }),
      _createElementVNode("main", _hoisted_2, [
        _createVNode(ConfigSubsection, { subtitle: "Conversas" }, {
          default: _withCtx(() => [
            _createVNode(ChatConfig)
          ]),
          _: 1
        }),
        _hoisted_3,
        _createVNode(ConfigSubsection, {
          class: "min-w-[900px] grid grid-cols-1",
          subtitle: "Provedor"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerProviders.value, (partnerProvider) => {
              return (_openBlock(), _createBlock(PartnerProviderCard, {
                partnerProvider: partnerProvider,
                key: partnerProvider.id,
                "display-toast": showToastMessage
              }, null, 8, ["partnerProvider"]))
            }), 128)),
            (!showAddPartnerProvider.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(Button), {
                    onClick: _cache[0] || (_cache[0] = () => showAddPartnerProvider.value = true),
                    class: "bg-blue-700 text-white rounded-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Adicionar mais ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (showAddPartnerProvider.value)
              ? (_openBlock(), _createBlock(PartnerProviderCreationForm, {
                  key: 1,
                  onCancel: disableCreationForm,
                  onCreationFinished: disableCreationForm,
                  "display-toast": showToastMessage
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Toaster)
  ], 64))
}
}

})